import createAsyncActionType from "../utilities/createAsyncActionType";

export const GET_ORGANIZATIONS = createAsyncActionType("GET_ORGANIZATIONS");
export const ORGANIZATION_AUTHENTICATION = createAsyncActionType(
  "ORGANIZATION_AUTHENTICATION"
);



// WEBPACK FOOTER //
// ./src/types/organizationTypes.js